import React from "react";
import { Route, Switch } from "react-router-dom";
import ForecastList from "./Forecasts";
import Summary from "./Summary";

function Forecasts({ match }) {
  const { path } = match;
  return (
    <Switch>
      <Route exact path={path} component={ForecastList} />
      <Route path={`${path}/:id`} component={Summary} />
    </Switch>
  );
}

export { Forecasts };
